import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import AiChatbot from './AiChatbot'
import StockAnalysis from '../../StockAnalysis'
import StockChat from '../../StockChat'

const AI_bot = () => {
    return (
        <Routes>
            <Route path="/" element={<AiChatbot />} />
            <Route path="stock/:symbol" element={<StockAnalysis />} />
            <Route path="stock/:symbol/chat" element={<StockChat />} />
        </Routes>
    )
}

export default AI_bot
